module.exports = __webpack_public_path__ + "img/Group_2.3f4f0700.png";